"use client";

;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { use } from "react";
import { OnboardingToursContext } from "@/features/onboarding-tours/context/onboarding-tours-context";
export function useOnboardingTours() {
  const context = use(OnboardingToursContext);
  if (!context) {
    throw new Error("useOnboardingTours must be used within OnboardingToursProvider");
  }
  return context;
}